import {
  COMMON_TOGGLE_SIDEBAR,
  COMMON_CHANGE_SELECT_LANGUAGE,
  COMMON_DATAVIEW_GET_DATA_REQUEST,
  COMMON_DATAVIEW_GET_DATA_RESULT,
  GENERATE_VALIDATION_CODE,
  GENERATE_VALIDATION_CODE_RESULT,
  CLEAR_REDUX
} from 'Redux/actionTypes';

const INIT_STATE = {
  sidebarShow: true,
  language: localStorage.getItem('lan') || 'en',
  loadingDataView: false,
  errorDataView: null,
  defaultList: [],
  change: false,
  loadingVfCode: false,
  VfCodeResult: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case COMMON_TOGGLE_SIDEBAR:
      return { ...state, sidebarShow: action.payload.open };

    case COMMON_CHANGE_SELECT_LANGUAGE:
      return { ...state, language: action.payload, change: true }

    case COMMON_DATAVIEW_GET_DATA_REQUEST:
      return { ...state, loadingDataView: true, [`loading-${action.payload.entity}`]: true }

    case COMMON_DATAVIEW_GET_DATA_RESULT:
      const { entity, items, total, error } = action.payload;
      return { ...state, loadingDataView: false, [`loading-${action.payload.entity}`]: false, [entity]: { items: items || [], total: total || 0 }, errorDataView: error || null }

    case GENERATE_VALIDATION_CODE:
      return { ...state, loadingVfCode: true }

    case GENERATE_VALIDATION_CODE_RESULT:
      return { ...state, loadingVfCode: false, VfCodeResult: action.payload }

    case CLEAR_REDUX:
      return ["", "COMMON"].includes(action.payload.option)
        ? action.payload.parameters
          ? { ...state, ...action.payload.parameters }
          : { ...INIT_STATE }
        : { ...state }

    default:
      return state;
  }
};
